import { useNavigate } from 'react-router-dom';
import { haptic } from '../lib/tg';

export default function TopBar({ title, right, back = true }: { title: string; right?: React.ReactNode; back?: boolean }) {
  const navigate = useNavigate();
  return (
    <div className="sticky top-0 z-30 flex items-center gap-3 px-4 py-3 bg-bg/95 backdrop-blur border-b border-line">
      {back ? (
        <button
          onClick={() => { haptic('light'); navigate(-1); }}
          className="w-9 h-9 rounded-full bg-bg-elev grid place-items-center active:bg-bg-card"
          aria-label="Назад"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M15 6l-6 6 6 6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      ) : (
        <span className="w-9" />
      )}
      <h1 className="flex-1 text-base font-semibold truncate">{title}</h1>
      {right}
    </div>
  );
}
